import { JobStatus } from "../../models/enum/job-status.enum";
import { JobType } from "../../models/enum/job-type.enum";
import { JobModel } from "../../models/job.model";
import { JobMediaContext } from "../../models/media/media-context.enum";
import { BaseService } from "../base.service";

export class JobService extends BaseService {
  constructor() {
    super();
  }

  async get(id: string): Promise<JobModel> {
    const resp = await this.client.get(`/super/job?id=${id}`);
    return resp.data;
  }

  async getList(  
    filter?: {
      companyId?: string;
      status?: JobStatus | string;
      type?: JobType | string;
      statusDateRange?: {
        from: Date;
        to: Date;
      };
    },
    region?: "AU" | "PH",
    page?: number,
    pageSize?: number,
    sort?: {
      accessor: string;
      direction: 0 | 1;
    }
  ): Promise<{
    data: JobModel[];
    totalItems: number;
    totalPage: number;
  }> {
    const resp = await this.client.post(`/super/job/list`, {
      filter,
      region,
      page,
      pageSize,
      sort,
    });
    
    return resp.data;
  }

  /**
   * Converts job generated from API to inventory (standard) job
   */
  async convertToInventory(id: string) {
    const resp = await this.client.put(`/super/job/convert/inventory`, { id });
    return resp.data;
  }

  async post(data: any): Promise<any> {
    const resp = await this.client.post(`/super/job`, data);
    return resp.data;
  }

  async update(data: any): Promise<any> {
    const resp = await this.client.put(`/super/job`, data);
    return resp.data;
  }

  async updateStatus(data: any) {
    return await this.client.put(`/super/job/status`, data);
  }

  async delete(id: string) {
    const resp = await this.client.put(`/super/job/delete`, { id });
    return resp.data;
  }

  async uploadAttachment(jobId: string, type: JobMediaContext, data: any) {
    let url = `/super/job/media/upload?jobId=${jobId}&type=${type}`;

    const resp = await this.client.post(url, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return resp?.data;
  }

  async deleteAttachment(mediaId: string, fileName: string) {
    await this.client.post(`/super/job/media/delete`, { mediaId, fileName });
  }

  async sendQuote(id: string) {
    await this.client.post(`/super/job/quote/send`, { id });
  }
}

export const jobService = new JobService();
